export const INVERT_LIGHTNESS_THRESHOLD = 165;

/**
 * @param {String}  h Hex color value.
 * @return {Array}  List of rgb values.
 */
export function hex2rgb(h: any) {
  if (!h) {
    return [0, 0, 0];
  }
  if (h.charAt(0) === "#") {
    h = h.substr(1);
  }
  const r = parseInt(h[0].toString() + h[1].toString(), 16);
  const g = parseInt(h[2].toString() + h[3].toString(), 16);
  const b = parseInt(h[4].toString() + h[5].toString(), 16);
  return [r, g, b];
}

export function rgb2hex(rgb: any) {
  return (
    "#" +
    rgb
      .map((c: any) => {
        const hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
      })
      .join("")
  );
}

export function darken(h: any, amount = 0.25) {
  let rgb = hex2rgb(h);
  rgb = rgb.map((c: any) => Math.round(c * (1 - amount)));
  return rgb2hex(rgb);
}

/**
 * @param {string}  h Hex color value.
 * @return {boolean}   True if color is light enough to warrant black foreground color.
 */
export function fgInvert(h: string): boolean {
  const [r, g, b] = hex2rgb(h);

  if (r && g && b) {
    const lightness = Math.sqrt(r * r * 0.241 + g * g * 0.691 + b * b * 0.068);
    return lightness > INVERT_LIGHTNESS_THRESHOLD;
  }

  return false;
}
